import { Chip, Stack, Tooltip } from '@mui/material';
import { TDataTableGridIcons, TDataTableGridLegend } from './constants';
import { getCellIcon } from './utils';

type TTableWidgetIconLegendProps = {
  baseTestId?: string;
  iconsConfig: TDataTableGridIcons | undefined;
  legendConfig: TDataTableGridLegend | undefined;
  title?: string;
};

const TableWidgetIconLegend = ({
  baseTestId,
  iconsConfig,
  legendConfig,
  title,
}: TTableWidgetIconLegendProps) => {
  if (!iconsConfig || !legendConfig) return null;
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={2}
      data-testid={`${baseTestId ?? 'table-widget'}-legend`}
      aria-label={`${title ?? ''} Legend`}
      sx={[
        {
          justifyContent: 'center',
          alignItems: 'center',
        },
        (theme) => ({
          '& .MuiChip-root': {
            padding: theme.spacing(0.5),
            opacity: 0.88,
          },
        }),
      ]}
    >
      {Object.entries(legendConfig)?.map(([key, value]) => {
        return (
          <Tooltip
            key={key}
            title={value?.tooltip ?? ''}
            placement="top"
            arrow
            enterTouchDelay={0}
          >
            <Chip
              data-testid={`legend-item-${key}`}
              icon={getCellIcon(iconsConfig?.list?.[value.icon]?.icon)}
              aria-label={value.title}
              label={value?.title ?? ''}
              size="small"
              sx={(theme) => ({
                // @ts-ignore
                background: theme.blox.table?.[value?.variant ?? 'neutral'],
                color: theme.blox.table.text,
                fontWeight: 500,
              })}
            />
          </Tooltip>
        );
      })}
    </Stack>
  );
};

export default TableWidgetIconLegend;
